

import { ShowErrorMsg, addAlert } from "../Components/Alerts/Alerts";
import axiosClient from "./axiosClient";

const postData = async (newData, URL_CREATE, changeLoadingState, success, closeModal) => {
  try {
    const response = await axiosClient.post(URL_CREATE, newData);

    if(response.status === 200){

      console.log({closeModal})
      addAlert();
      if (success) success(response.data);
      if (closeModal) closeModal();
    }


    return response.data;
  } catch (error) {
    
    ShowErrorMsg(error);      
    
    return error.response?.data;

  } finally {
    if (changeLoadingState) changeLoadingState(false);
  }
};

export default postData;